export const entityTypes = {
  EVENT: 'event',
  CLASS: 'class' // class is a hybird that is occurrence + course data
};
